"use client";
import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { SelectRoot as i, SelectTrigger as m, SelectValue as u } from "../../atoms/Select/Select.mjs";
import { cn as k } from "../../../utils/utils.mjs";
const S = ({
  className: r,
  children: t,
  iconPrefix: a,
  iconSuffix: l,
  placeholder: n,
  selectTriggerProps: o,
  selectValueProps: d,
  ...c
}) => /* @__PURE__ */ s(i, { ...c, children: [
  /* @__PURE__ */ e(
    m,
    {
      iconPrefix: a,
      iconSuffix: l,
      className: k(
        "min-w-38 p-4 rounded-sm dark:bg-neutral-dark-200 dark:hover:not-disabled:bg-neutral-dark-400 dark:text-neutral-dark-1000",
        r
      ),
      ...o,
      children: /* @__PURE__ */ e(u, { placeholder: n, ...d })
    }
  ),
  t
] });
export {
  S as SelectInput
};
